/* HP 13-10: rustige crossfade naar de volgende productfoto's bij hover (alleen desktop met muis). */
(function () {
  if (!window.matchMedia) return;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
  var STEP = 1800;

  function load(img) {
    if (!img.getAttribute('srcset') && img.dataset.hpSrcset) img.setAttribute('srcset', img.dataset.hpSrcset);
    return img.complete && img.naturalWidth ? Promise.resolve() : new Promise(function (res) {
      img.addEventListener('load', res, { once: true });
      img.addEventListener('error', res, { once: true });
    });
  }

  function stop(link) {
    clearTimeout(link._hpTimer);
    link._hpActive = false;
    link.querySelectorAll('.hp-fade-img.is-on').forEach(function (i) { i.classList.remove('is-on'); });
  }

  function show(link, imgs, i) {
    if (!link._hpActive) return;
    var img = imgs[i];
    load(img).then(function () {
      if (!link._hpActive || !img.naturalWidth) return;
      imgs.forEach(function (o) { if (o !== img) o.classList.remove('is-on'); });
      img.classList.add('is-on');
      if (imgs.length > 1) {
        if (i + 1 < imgs.length) load(imgs[i + 1]);
        link._hpTimer = setTimeout(function () { show(link, imgs, (i + 1) % imgs.length); }, STEP);
      }
    });
  }

  function start(card) {
    if (!fine.matches || calm.matches) return;
    var link = card.querySelector('[data-hp-fade]');
    if (!link || link._hpActive) return;
    var imgs = Array.prototype.slice.call(link.querySelectorAll('.hp-fade-img'));
    if (!imgs.length) return;
    link._hpActive = true;
    if (!card._hpBound) {
      card._hpBound = true;
      card.addEventListener('pointerleave', function () { stop(link); });
    }
    show(link, imgs, 0);
  }

  document.addEventListener('pointerover', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var card = e.target.closest && e.target.closest('product-card, .card--product');
    if (card) start(card);
  }, { passive: true });
})();
